module.exports = __webpack_public_path__ + "static/img/25Q1_NC_MotorShow.62e32a6.jpg";